import { Button } from '@progress/kendo-react-buttons'
import { useSurveyCtx, useUserResponseCtx } from '../../../Context/SurveyContext'
import { SurveyEngine_Models_Block } from '../../../api';
import { useBlockCtx, useBlockDispatchCtx } from '../../../Context/BlockContext';
interface PreviousButtonProps
{
  text : string,
  getPreviousQuestionCommand:(surveyInstanceID:string,showPreviousRes:boolean)=> void
}

export default function PreviousButton(props: PreviousButtonProps) {

  const blockCtx = useBlockCtx();
  const blockDispatchCtx =  useBlockDispatchCtx();
  const surveyCtx = useSurveyCtx();
  const userResCtx = useUserResponseCtx()
   const handlePreviousQuestion = () => {

    let callPrevious:boolean= true;
    if(surveyCtx.NextQuestion.commandType === 'Block')
    {
      let block = surveyCtx.NextQuestion as SurveyEngine_Models_Block;
      if(block && !block.keepOnPage && blockCtx.currentIndex > 0)
      {
          callPrevious = false;
      }
      if(block && block.keepOnPage)
      {
        blockDispatchCtx({ type: "ResetCommandIndexFocus", value: true })
      }
    }
    if(callPrevious)
    {
      props.getPreviousQuestionCommand(surveyCtx.StartSurvey.surveyInstanceId!,surveyCtx.StartSurvey.showPreviousResponse!);
    }
    else
    {
      if(!surveyCtx.StartSurvey.showPreviousResponse!)
      {
        let ansIndex = userResCtx.current.findIndex(res => res.commandIndex === (surveyCtx.NextQuestion as SurveyEngine_Models_Block).commands![blockCtx.currentIndex].commandIndex)
        if (ansIndex !== -1) {
          userResCtx.current.splice(ansIndex, 1)
        }
        ansIndex = userResCtx.current.findIndex(res => res.commandIndex === (surveyCtx.NextQuestion as SurveyEngine_Models_Block).commands![blockCtx.currentIndex - 1].commandIndex)
        if (ansIndex !== -1) {
          userResCtx.current.splice(ansIndex, 1)
        }
      }
      blockDispatchCtx({ type: "UpdateIndex", value: blockCtx.currentIndex - 1 })
    }
    
    
  }

  const isBackButtonDisabled = () => {

    let isBlockWithKeepOnPage:boolean= true;
/*     if(surveyCtx.NextQuestion.commandType === 'Block')
    {
      let block = surveyCtx.NextQuestion as SurveyEngine_Models_Block;
      if(block && !block.keepOnPage)
      {
        isBlockWithKeepOnPage = false;
      }
    } */

    if(surveyCtx.ProgressBarCounter === surveyCtx.FirstCommandIndex || surveyCtx.ProgressBarCounter <= 0 || !isBlockWithKeepOnPage)
    {
      return true;
    }
    return false;

  }
  return (
    <Button
      disabled={isBackButtonDisabled()}
      onClick={() => handlePreviousQuestion()}
      className="theme-btn-previous font-bold w-full md:w-auto"
      data-testid="previous-btn"
    >
      {props.text}
    </Button>
  )
}
